import './utahshoglezoo/style';
import FormStructure from './utahshoglezoo/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js